// 设置 rem 函数
function setRem() {
    // 设置页面根节点字体大小
    let rootFontSize =  window.innerWidth / 10
    document.documentElement.style.fontSize = rootFontSize + "px";
}

// 初始化
setTimeout(() => {
    setRem();
}, 100);
// 改变窗口大小时重新设置 rem
window.onresize = function() {
  setRem();
};